export default {"src":"/_next/static/media/flutter-icon.4ce823e9.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};